<div
  class="flex h-fit flex-col justify-around gap-10 rounded-md border border-gray-100/10 bg-gray-100/10 p-7 backdrop-blur-md">
  <div>
    <h1 class="text-3xl font-bold text-white">Iniciar Sesión</h1>
    <span class="text-xs text-gray-200">
      ¿Olvidaste tu contraseña? Cámbiala
      <a routerLink="/forgot-password" class="underline">aquí</a>
    </span>
  </div>

  <form
    id="login-form"
    (submit)="login($event)"
    class="flex w-full flex-col justify-center gap-5">
    <app-input-text
      inputID="email"
      icon="matMailOutline"
      placeholder="Correo Electrónico"
      [field]="loginForm.email" />

    <app-input-password
      inputID="password"
      icon="matLockOutline"
      placeholder="Contraseña"
      [field]="loginForm.password" />

    <button
      class="mt-2 cursor-pointer rounded-md border border-white/5 bg-[#36181c]/90 py-2.5 font-semibold text-white backdrop-blur transition-colors hover:bg-black disabled:cursor-not-allowed disabled:opacity-50"
      type="submit"
      form="login-form"
      [disabled]="loginForm().invalid()">
      Iniciar Sesión
    </button>
  </form>
</div>
